module.exports = __webpack_public_path__ + "img/btn_mafia_on.33158802.svg";